import React from "react";
import FaqsAccordion from "../../faqs/FaqsAccordion";

function SocialMediaFaqs() {
  const accordionItems = [
    {
      title:
        "Customer Security", 
      content:
        "Safeguard user data and build long-term trust with end-to-end protection.",
    },
    {
      title:
        "Online Protection",
      content:
        "Prevent breaches and downtime with proactive defense on all digital fronts.",
    },
    {
      title: "Risk Visibility",
      content:
        "Gain clear insights into your cybersecurity posture and vulnerabilities.",
    },
    {
      title: "Threat Detection",
      content:
        "Identify and stop threats before they impact your business.",
    },
    {
      title: "Compliance Readiness",
      content:
        "Stay aligned with global security and privacy standards, effortlessly.",
    },
  ];
  return (
    <div className="accordionWrap">
      <FaqsAccordion items={accordionItems} />
    </div>
  );
}

export default SocialMediaFaqs;
